/* Guías del resto: cuenta, privacidad, móvil, ayuda. Ver ../guides.js */

export const GUIDES_MORE = [
  {
    slug: 'collaborators',
    id: 'collaborators',
    category: 'more',
    icon: 'users',
    level: 'medium',
    plan: 'pro',
    minutes: 4,
    topics: [
      'col·laboradors', 'colaboradores', 'collaborators', 'compartir correo', 'compartir correu',
      'que me ayude alguien', 'delegar', 'secretaria', 'mi hijo me ayuda', 'compartir conversación',
      'share thread', 'trabajar en equipo',
    ],
    ca: {
      title: 'Demanar ajuda a una altra persona amb un correu',
      lead: 'Sense reenviar cadenes interminables: compartiu la conversa i la comenteu al costat.',
      answer:
        'Al panell de col·laboradors pots convidar una altra persona amb compte de Nukli. Quan accepti, podràs compartir-hi converses concretes i parlar-ne en un xat privat que el remitent del correu no veu mai.',
      steps: [
        {
          t: 'Obre els col·laboradors',
          d: 'Botó de la barra d’icones de l’esquerra. Hi ha les sol·licituds enviades, les rebudes i la gent amb qui ja col·labores.',
          screen: 'collaborators',
          highlight: 'rail',
        },
        {
          t: 'Convida per correu',
          d: 'Escriu la seva adreça i prem “Convida”. Aquella persona ha de tenir compte de Nukli i acceptar-ho.',
          screen: 'collaborators',
          highlight: 'invite',
        },
        {
          t: 'Comparteix una conversa',
          d: 'Al correu obert, tria “Afegeix col·laboradors”. Pots deixar-la només per llegir o permetre que respongui.',
          screen: 'reader',
          highlight: 'collab',
        },
        {
          t: 'Parleu-ne al xat privat',
          d: 'Cada conversa compartida té un xat de comentaris entre vosaltres. El destinatari del correu no el veu mai.',
          screen: 'collaborators',
          highlight: 'shared',
        },
        {
          t: 'Deixa de compartir quan acabeu',
          d: 'Al mateix menú del correu obert pots treure la compartició. La conversa torna a ser només teva.',
          screen: 'reader',
          highlight: 'head',
        },
      ],
      tips: [
        'Molt útil per a una persona gran i un familiar que l’ajuda: veieu el mateix correu i el comenteu sense reenviaments.',
        'Cal un pla Pro+ o superior per convidar col·laboradors.',
      ],
      faq: [
        {
          q: 'Veurà tot el meu correu?',
          a: 'No. Només les converses que li comparteixis expressament, d’una en una.',
        },
        {
          q: 'Pot respondre en nom meu?',
          a: 'Només si li has donat permís per respondre. Si no, pot llegir i comentar, però no enviar.',
        },
      ],
    },
    es: {
      title: 'Pedir ayuda a otra persona con un correo',
      lead: 'Sin reenviar cadenas interminables: compartís la conversación y la comentáis al lado.',
      answer:
        'En el panel de colaboradores puedes invitar a otra persona con cuenta de Nukli. Cuando acepte, podrás compartir conversaciones concretas y hablar de ellas en un chat privado que el remitente del correo nunca ve.',
      steps: [
        {
          t: 'Abre los colaboradores',
          d: 'Botón de la barra de iconos de la izquierda. Están las solicitudes enviadas, las recibidas y la gente con la que ya colaboras.',
          screen: 'collaborators',
          highlight: 'rail',
        },
        {
          t: 'Invita por correo',
          d: 'Escribe su dirección y pulsa “Invitar”. Esa persona debe tener cuenta de Nukli y aceptarlo.',
          screen: 'collaborators',
          highlight: 'invite',
        },
        {
          t: 'Comparte una conversación',
          d: 'En el correo abierto, elige “Añadir colaboradores”. Puedes dejarla solo para leer o permitir que responda.',
          screen: 'reader',
          highlight: 'collab',
        },
        {
          t: 'Habladlo en el chat privado',
          d: 'Cada conversación compartida tiene un chat de comentarios entre vosotros. El destinatario del correo no lo ve nunca.',
          screen: 'collaborators',
          highlight: 'shared',
        },
        {
          t: 'Deja de compartir cuando acabéis',
          d: 'En el mismo menú del correo abierto puedes quitar la compartición. La conversación vuelve a ser solo tuya.',
          screen: 'reader',
          highlight: 'head',
        },
      ],
      tips: [
        'Muy útil para una persona mayor y un familiar que la ayuda: veis el mismo correo y lo comentáis sin reenvíos.',
        'Hace falta un plan Pro+ o superior para invitar colaboradores.',
      ],
      faq: [
        {
          q: '¿Verá todo mi correo?',
          a: 'No. Solo las conversaciones que le compartas expresamente, una a una.',
        },
        {
          q: '¿Puede responder en mi nombre?',
          a: 'Solo si le has dado permiso para responder. Si no, puede leer y comentar, pero no enviar.',
        },
      ],
    },
    en: {
      title: 'Asking someone else for help with an email',
      lead: 'No endless forwarding: you share the conversation and discuss it alongside.',
      answer:
        'In the collaborators panel you can invite another person who has a Nukli account. Once they accept, you can share specific conversations and talk them over in a private chat the email’s sender never sees.',
      steps: [
        {
          t: 'Open collaborators',
          d: 'Button in the icon bar on the left. It holds requests sent, requests received, and the people you already work with.',
          screen: 'collaborators',
          highlight: 'rail',
        },
        {
          t: 'Invite by email',
          d: 'Type their address and press “Invite”. They need a Nukli account and have to accept.',
          screen: 'collaborators',
          highlight: 'invite',
        },
        {
          t: 'Share a conversation',
          d: 'On the open email, choose “Add collaborators”. You can leave it read-only or let them reply.',
          screen: 'reader',
          highlight: 'collab',
        },
        {
          t: 'Talk it over in the private chat',
          d: 'Every shared conversation has a comment chat between you. The email’s recipient never sees it.',
          screen: 'collaborators',
          highlight: 'shared',
        },
        {
          t: 'Stop sharing when you are done',
          d: 'The same menu on the open email removes the sharing. The conversation is yours alone again.',
          screen: 'reader',
          highlight: 'head',
        },
      ],
      tips: [
        'Very useful for an older person and the relative who helps them: you both see the same email and discuss it without forwarding.',
        'Inviting collaborators needs a Pro+ plan or higher.',
      ],
      faq: [
        {
          q: 'Will they see all my mail?',
          a: 'No. Only the conversations you explicitly share, one at a time.',
        },
        {
          q: 'Can they reply on my behalf?',
          a: 'Only if you gave them permission to reply. Otherwise they can read and comment, but not send.',
        },
      ],
    },
  },

  {
    slug: 'connect-services',
    id: 'connect-services',
    category: 'more',
    icon: 'plug-zap',
    level: 'advanced',
    plan: 'proplus',
    minutes: 5,
    topics: [
      'connectar serveis', 'conectar servicios', 'mcp', 'stripe', 'shopify', 'notion', 'hubspot',
      'github', 'linear', 'integraciones', 'integracions', 'conectar herramientas', 'connect apps',
      'consultar pedidos', 'datos reales',
    ],
    ca: {
      title: 'Connectar Stripe i altres serveis que ja fas servir',
      lead: 'Perquè l’assistent contesti amb dades de veritat: aquest client ha pagat, aquesta comanda va sortir dimarts.',
      answer:
        'Al panell de connexions pots enllaçar serveis com Stripe, Notion, Shopify o HubSpot. L’assistent els consulta sol mentre llegeixes un correu; per canviar-hi res, et deixa l’acció preparada al xat i no passa res fins que prems “Executa”. Cal el pla Pro+.',
      steps: [
        {
          t: 'Obre les connexions',
          d: 'Botó de la barra d’icones de l’esquerra. Hi ha el catàleg de serveis i les connexions que ja tinguis.',
          screen: 'mcp',
          highlight: 'rail',
        },
        {
          t: 'Tria el servei',
          d: 'Els que hi surten estan guiats pas a pas: t’explica què necessites i on trobar-ho.',
          screen: 'mcp',
          highlight: 'catalog',
        },
        {
          t: 'Aconsegueix la clau',
          d: 'La majoria demanen una clau, que és com una contrasenya que dona permís a Nukli i que pots anul·lar quan vulguis. Crea-la amb els mínims permisos possibles.',
        },
        {
          t: 'Enganxa-la i comprova',
          d: 'Nukli prova la connexió i et diu quantes accions tens disponibles.',
          screen: 'mcp',
          highlight: 'connected',
        },
        {
          t: 'Fes-la servir des del correu',
          d: 'Amb un correu obert: “aquest client ha pagat?”, “quan va sortir la seva comanda?”. Ho consulta i t’ho diu; si cal canviar res, et deixa el botó preparat.',
          screen: 'chat-proposal',
          highlight: 'proposal',
        },
      ],
      tips: [
        'Llegir és automàtic; escriure (cobrar, cancel·lar, modificar) sempre demana que ho confirmis tu al xat.',
        'Si un servei et fa nosa, el pots pausar sense esborrar la connexió.',
      ],
      faq: [
        {
          q: 'És perillós donar-li una clau?',
          a: 'Es guarda xifrada i la pots revocar des del servei quan vulguis. Crea sempre una clau amb els permisos mínims.',
        },
        {
          q: 'Ho necessito?',
          a: 'Si portes una botiga, clients o projectes, és el que fa que les respostes deixin de ser genèriques. Per al correu personal no cal.',
        },
      ],
    },
    es: {
      title: 'Conectar Stripe y otros servicios que ya usas',
      lead: 'Para que el asistente conteste con datos de verdad: este cliente ha pagado, este pedido salió el martes.',
      answer:
        'En el panel de conexiones puedes enlazar servicios como Stripe, Notion, Shopify o HubSpot. El asistente los consulta solo mientras lees un correo; para cambiar algo, te deja la acción preparada en el chat y no pasa nada hasta que pulsas “Ejecutar”. Hace falta el plan Pro+.',
      steps: [
        {
          t: 'Abre las conexiones',
          d: 'Botón de la barra de iconos de la izquierda. Ahí está el catálogo de servicios y las conexiones que ya tengas.',
          screen: 'mcp',
          highlight: 'rail',
        },
        {
          t: 'Elige el servicio',
          d: 'Los que aparecen están guiados paso a paso: te explica qué necesitas y dónde encontrarlo.',
          screen: 'mcp',
          highlight: 'catalog',
        },
        {
          t: 'Consigue la clave',
          d: 'La mayoría piden una clave, que es como una contraseña que da permiso a Nukli y que puedes anular cuando quieras. Créala con los mínimos permisos posibles.',
        },
        {
          t: 'Pégala y comprueba',
          d: 'Nukli prueba la conexión y te dice cuántas acciones tienes disponibles.',
          screen: 'mcp',
          highlight: 'connected',
        },
        {
          t: 'Úsala desde el correo',
          d: 'Con un correo abierto: “¿este cliente ha pagado?”, “¿cuándo salió su pedido?”. Lo consulta y te lo dice; si hay que cambiar algo, te deja el botón preparado.',
          screen: 'chat-proposal',
          highlight: 'proposal',
        },
      ],
      tips: [
        'Leer es automático; escribir (cobrar, cancelar, modificar) siempre pide que lo confirmes tú en el chat.',
        'Si un servicio te estorba, puedes pausarlo sin borrar la conexión.',
      ],
      faq: [
        {
          q: '¿Es peligroso darle una clave?',
          a: 'Se guarda cifrada y puedes revocarla desde el servicio cuando quieras. Crea siempre una clave con permisos mínimos.',
        },
        {
          q: '¿Lo necesito?',
          a: 'Si llevas una tienda, clientes o proyectos, es lo que hace que las respuestas dejen de ser genéricas. Para el correo personal no hace falta.',
        },
      ],
    },
    en: {
      title: 'Connecting Stripe and other services you already use',
      lead: 'So the assistant answers with real facts: this customer has paid, this order shipped on Tuesday.',
      answer:
        'In the connections panel you can link services such as Stripe, Notion, Shopify or HubSpot. The assistant looks things up on its own while you read an email; to change anything it leaves the action ready in the chat and nothing happens until you press “Run”. Requires the Pro+ plan.',
      steps: [
        {
          t: 'Open connections',
          d: 'Button in the icon bar on the left. It holds the service catalogue and any connections you already have.',
          screen: 'mcp',
          highlight: 'rail',
        },
        {
          t: 'Pick the service',
          d: 'The listed ones are guided step by step: it explains what you need and where to find it.',
          screen: 'mcp',
          highlight: 'catalog',
        },
        {
          t: 'Get the key',
          d: 'Most ask for a key — a password-like token that grants Nukli permission and that you can revoke at any time. Create it with the fewest possible permissions.',
        },
        {
          t: 'Paste it and check',
          d: 'Nukli tests the connection and tells you how many actions are available.',
          screen: 'mcp',
          highlight: 'connected',
        },
        {
          t: 'Use it from your mail',
          d: 'With an email open: “has this customer paid?”, “when did their order ship?”. It looks it up and tells you; if something needs changing, it leaves the button ready.',
          screen: 'chat-proposal',
          highlight: 'proposal',
        },
      ],
      tips: [
        'Reading is automatic; writing (charging, cancelling, changing) always asks you to confirm in the chat.',
        'If a service gets in the way you can pause it without deleting the connection.',
      ],
      faq: [
        {
          q: 'Is giving it a key risky?',
          a: 'It is stored encrypted and you can revoke it from the service whenever you like. Always create a key with minimal permissions.',
        },
        {
          q: 'Do I need this?',
          a: 'If you run a shop, clients or projects, this is what stops replies being generic. For personal mail you can skip it.',
        },
      ],
    },
  },

  {
    slug: 'notifications',
    id: 'notifications',
    category: 'more',
    icon: 'bell-ring',
    level: 'basic',
    plan: 'free',
    minutes: 2,
    topics: [
      'notificacions', 'notificaciones', 'notifications', 'avisos', 'campana', 'campaneta',
      'no me avisa', 'demasiados avisos', 'sonido', 'alerta de correo nuevo',
    ],
    ca: {
      title: 'Els avisos: la campaneta i el correu nou',
      lead: 'Assabentar-te del que importa sense que l’ordinador et cridi cada dos minuts.',
      answer:
        'La campaneta de la barra d’icones és el centre de notificacions de dins la app: correu nou, peticions de col·laboració i comentaris. Els avisos del sistema (els que surten a la cantonada de la pantalla) es demanen la primera vegada i es gestionen des de la configuració del teu ordinador.',
      steps: [
        {
          t: 'Obre la campaneta',
          d: 'A la part baixa de la barra d’icones. Hi surten els avisos pendents.',
          screen: 'notifications',
          highlight: 'rail',
        },
        {
          t: 'Prem un avís per anar-hi',
          d: 'Cada avís et porta al correu, a la conversa compartida o al panell de col·laboradors.',
          screen: 'notifications',
          highlight: 'list',
        },
        {
          t: 'Decideix sobre els avisos del sistema',
          d: 'La primera vegada Nukli et pregunta si vols que t’avisi el sistema quan arribi correu nou. Després es canvia a Configuració > General.',
          screen: 'settings-general',
          highlight: 'notifications',
        },
      ],
      tips: [
        'Si un fil concret t’avisa massa, silencia’l amb el botó dret sobre el correu.',
        'Els avisos del sistema es poden tornar a activar (o apagar) des de la configuració de notificacions del teu ordinador.',
      ],
      faq: [
        {
          q: 'No em surt cap avís',
          a: 'Comprova que has donat permís de notificacions al sistema i que la app està oberta o en segon pla.',
        },
      ],
    },
    es: {
      title: 'Los avisos: la campanita y el correo nuevo',
      lead: 'Enterarte de lo que importa sin que el ordenador te grite cada dos minutos.',
      answer:
        'La campanita de la barra de iconos es el centro de notificaciones dentro de la app: correo nuevo, peticiones de colaboración y comentarios. Los avisos del sistema (los que salen en la esquina de la pantalla) se piden la primera vez y se gestionan desde los ajustes de tu ordenador.',
      steps: [
        {
          t: 'Abre la campanita',
          d: 'En la parte baja de la barra de iconos. Ahí salen los avisos pendientes.',
          screen: 'notifications',
          highlight: 'rail',
        },
        {
          t: 'Pulsa un aviso para ir',
          d: 'Cada aviso te lleva al correo, a la conversación compartida o al panel de colaboradores.',
          screen: 'notifications',
          highlight: 'list',
        },
        {
          t: 'Decide sobre los avisos del sistema',
          d: 'La primera vez Nukli te pregunta si quieres que el sistema te avise al llegar correo nuevo. Luego se cambia en Ajustes > General.',
          screen: 'settings-general',
          highlight: 'notifications',
        },
      ],
      tips: [
        'Si un hilo concreto te avisa demasiado, siléncialo con el botón derecho sobre el correo.',
        'Los avisos del sistema se pueden volver a activar (o apagar) desde los ajustes de notificaciones de tu ordenador.',
      ],
      faq: [
        {
          q: 'No me sale ningún aviso',
          a: 'Comprueba que has dado permiso de notificaciones al sistema y que la app está abierta o en segundo plano.',
        },
      ],
    },
    en: {
      title: 'Alerts: the bell and new mail',
      lead: 'Hearing about what matters without your computer shouting every two minutes.',
      answer:
        'The bell in the icon bar is the in-app notification centre: new mail, collaboration requests and comments. System alerts (the ones in the corner of your screen) are asked for the first time and managed from your computer’s settings.',
      steps: [
        {
          t: 'Open the bell',
          d: 'Near the bottom of the icon bar. Pending alerts appear there.',
          screen: 'notifications',
          highlight: 'rail',
        },
        {
          t: 'Press an alert to go there',
          d: 'Each one takes you to the email, the shared conversation or the collaborators panel.',
          screen: 'notifications',
          highlight: 'list',
        },
        {
          t: 'Decide about system alerts',
          d: 'The first time, Nukli asks whether you want the system to tell you about new mail. After that you change it in Settings > General.',
          screen: 'settings-general',
          highlight: 'notifications',
        },
      ],
      tips: [
        'If one thread is too noisy, mute it by right-clicking the email.',
        'System alerts can be turned back on (or off) in your computer’s notification settings.',
      ],
      faq: [
        {
          q: 'I get no alerts at all',
          a: 'Check you granted notification permission to the system and that the app is open or running in the background.',
        },
      ],
    },
  },

  {
    slug: 'your-plan-and-ai-usage',
    id: 'plan-usage',
    category: 'more',
    icon: 'chart-pie',
    level: 'basic',
    plan: 'free',
    minutes: 3,
    topics: [
      'pla', 'plan', 'suscripción', 'subscripció', 'precio', 'preu', 'pagar', 'cuota', 'quota',
      'consumo de ia', 'consum', 'usage', 'billing', 'cuánto me queda', 'se me ha acabado',
      'cancelar suscripción', 'factura', 'premium',
    ],
    ca: {
      title: 'El teu pla i el consum d’IA',
      lead: 'Què inclou el gratuït, què vol dir “se t’ha acabat la quota” i on es mira tot això.',
      answer:
        'A Configuració > Compte veuràs el teu pla, el que has consumit en aquest període i el desglossament per model. L’ús d’IA es mesura: cada resposta, resum o traducció en gasta una miqueta. Quan s’acaba, la app segueix funcionant com a correu normal.',
      steps: [
        {
          t: 'Obre el teu compte',
          d: 'Des del teu nom, a baix de la barra d’icones, o a Configuració > Compte.',
          screen: 'settings-account',
          highlight: 'tabs',
        },
        {
          t: 'Mira “Ús d’IA”',
          d: 'Diu quant portes gastat d’aquest període i quant et queda. També pots veure per on se’n va.',
          screen: 'settings-account',
          highlight: 'usage',
        },
        {
          t: 'Canvia de pla si et fa falta',
          d: 'Des del mateix lloc pots passar a un pla de pagament o gestionar la subscripció que ja tens.',
          screen: 'settings-account',
          highlight: 'plan',
        },
        {
          t: 'Si s’acaba, no passa res greu',
          d: 'El correu continua funcionant: llegir, escriure, enviar i buscar. El que s’atura són les funcions d’IA fins al període següent.',
        },
      ],
      tips: [
        'El període no va per mes natural: compta des del dia que et vas donar d’alta.',
        'Les respostes llargues i els resums de moltes converses gasten més que una correcció d’ortografia.',
      ],
      faq: [
        {
          q: 'El pla gratuït caduca?',
          a: 'No. És gratuït i inclou una quantitat d’IA cada període. El correu, sense límit.',
        },
        {
          q: 'Com anul·lo la subscripció?',
          a: 'Des de “Gestiona la subscripció”, al mateix apartat del compte. Pots cancel·lar quan vulguis.',
        },
      ],
    },
    es: {
      title: 'Tu plan y el consumo de IA',
      lead: 'Qué incluye el gratuito, qué significa “se te ha acabado la cuota” y dónde se mira todo esto.',
      answer:
        'En Ajustes > Cuenta verás tu plan, lo que has consumido en este periodo y el desglose por modelo. El uso de IA se mide: cada respuesta, resumen o traducción gasta un poquito. Cuando se acaba, la app sigue funcionando como correo normal.',
      steps: [
        {
          t: 'Abre tu cuenta',
          d: 'Desde tu nombre, abajo en la barra de iconos, o en Ajustes > Cuenta.',
          screen: 'settings-account',
          highlight: 'tabs',
        },
        {
          t: 'Mira “Uso de IA”',
          d: 'Dice cuánto llevas gastado de este periodo y cuánto te queda. También puedes ver en qué se va.',
          screen: 'settings-account',
          highlight: 'usage',
        },
        {
          t: 'Cambia de plan si te hace falta',
          d: 'Desde el mismo sitio puedes pasar a un plan de pago o gestionar la suscripción que ya tienes.',
          screen: 'settings-account',
          highlight: 'plan',
        },
        {
          t: 'Si se acaba, no pasa nada grave',
          d: 'El correo sigue funcionando: leer, escribir, enviar y buscar. Lo que se para son las funciones de IA hasta el periodo siguiente.',
        },
      ],
      tips: [
        'El periodo no va por mes natural: cuenta desde el día que te diste de alta.',
        'Las respuestas largas y los resúmenes de muchas conversaciones gastan más que una corrección de ortografía.',
      ],
      faq: [
        {
          q: '¿El plan gratuito caduca?',
          a: 'No. Es gratuito e incluye una cantidad de IA cada periodo. El correo, sin límite.',
        },
        {
          q: '¿Cómo anulo la suscripción?',
          a: 'Desde “Gestionar suscripción”, en el mismo apartado de la cuenta. Puedes cancelar cuando quieras.',
        },
      ],
    },
    en: {
      title: 'Your plan and your AI usage',
      lead: 'What the free plan includes, what “you have run out” means, and where to check it all.',
      answer:
        'Settings > Account shows your plan, what you have used this period and the breakdown per model. AI use is metered: each reply, summary or translation spends a little. When it runs out, the app keeps working as a normal email client.',
      steps: [
        {
          t: 'Open your account',
          d: 'From your name at the bottom of the icon bar, or Settings > Account.',
          screen: 'settings-account',
          highlight: 'tabs',
        },
        {
          t: 'Look at “AI usage”',
          d: 'It shows how much of this period you have spent and how much is left, and where it went.',
          screen: 'settings-account',
          highlight: 'usage',
        },
        {
          t: 'Change plan if you need to',
          d: 'From the same place you can move to a paid plan or manage the subscription you already have.',
          screen: 'settings-account',
          highlight: 'plan',
        },
        {
          t: 'Running out is not a disaster',
          d: 'Email keeps working: reading, writing, sending and searching. Only the AI features pause until the next period.',
        },
      ],
      tips: [
        'The period is not the calendar month: it counts from the day you signed up.',
        'Long replies and summaries of many conversations cost more than a spelling check.',
      ],
      faq: [
        {
          q: 'Does the free plan expire?',
          a: 'No. It is free and includes an amount of AI each period. Email itself is unlimited.',
        },
        {
          q: 'How do I cancel the subscription?',
          a: 'From “Manage subscription” in the same account section. You can cancel any time.',
        },
      ],
    },
  },

  {
    slug: 'privacy-and-security',
    id: 'privacy',
    category: 'more',
    icon: 'lock',
    level: 'basic',
    plan: 'free',
    minutes: 4,
    topics: [
      'privacitat', 'privacidad', 'privacy', 'seguridad', 'seguretat', 'security', 'mis datos',
      'les meves dades', 'quién ve mis correos', 'es seguro', 'és segur', 'contraseña', 'cifrado',
      'vender datos', 'confianza',
    ],
    ca: {
      title: 'Privacitat: què veu Nukli i què no',
      lead: 'La pregunta justa quan una app et demana el correu. Aquí va la resposta clara.',
      answer:
        'Nukli es connecta al teu correu amb credencials xifrades (AES-256-GCM). Amb Gmail i Microsoft entres a la seva pàgina i Nukli no veu mai la teva contrasenya. Les teves dades no es venen. L’assistent llegeix el correu que li obres per poder-te ajudar, i qualsevol acció que canviï coses la confirmes tu.',
      steps: [
        {
          t: 'Com hi entra',
          d: 'Amb Gmail i Microsoft, mitjançant l’autorització del proveïdor (tu entres a la seva pàgina). Amb IMAP, amb una contrasenya d’aplicació que pots anul·lar quan vulguis.',
          screen: 'settings-accounts',
          highlight: 'add',
        },
        {
          t: 'Com es guarden les claus',
          d: 'Xifrades amb AES-256-GCM. No hi ha cap pantalla que te les torni a ensenyar en clar.',
        },
        {
          t: 'Què llegeix l’assistent',
          d: 'El correu que tens obert i, quan ho demanes, els correus que et cal buscar o resumir. No es venen dades a tercers.',
        },
        {
          t: 'Qui prem els botons',
          d: 'Tu. Enviar, esborrar o modificar res en un servei connectat sempre passa per una confirmació teva: l’assistent deixa la targeta i tu prems Executa.',
          screen: 'chat-proposal',
          highlight: 'proposal',
        },
        {
          t: 'Com surts',
          d: 'Pots treure un compte de correu o tancar la sessió quan vulguis. Traient el compte, Nukli deixa d’accedir-hi.',
          screen: 'settings-account',
          highlight: 'plan',
        },
      ],
      tips: [
        'Consell general que va més enllà de Nukli: cap empresa seriosa et demanarà la contrasenya per correu electrònic.',
        'Si tens dubtes sobre un correu concret, pregunta-ho a l’assistent abans de prémer cap enllaç.',
      ],
      faq: [
        {
          q: 'Es guarden els meus correus en un servidor?',
          a: 'Nukli en desa una còpia per poder-te ensenyar la safata i buscar-hi de pressa. El teu proveïdor continua tenint els originals.',
        },
        {
          q: 'Puc fer servir Nukli sense IA?',
          a: 'Sí. És un client de correu complet; les funcions d’IA les fas servir només quan les demanes.',
        },
      ],
    },
    es: {
      title: 'Privacidad: qué ve Nukli y qué no',
      lead: 'La pregunta justa cuando una app te pide el correo. Aquí va la respuesta clara.',
      answer:
        'Nukli se conecta a tu correo con credenciales cifradas (AES-256-GCM). Con Gmail y Microsoft entras en su propia página y Nukli nunca ve tu contraseña. Tus datos no se venden. El asistente lee el correo que le abres para poder ayudarte, y cualquier acción que cambie cosas la confirmas tú.',
      steps: [
        {
          t: 'Cómo entra',
          d: 'Con Gmail y Microsoft, mediante la autorización del proveedor (entras tú en su página). Con IMAP, con una contraseña de aplicación que puedes anular cuando quieras.',
          screen: 'settings-accounts',
          highlight: 'add',
        },
        {
          t: 'Cómo se guardan las claves',
          d: 'Cifradas con AES-256-GCM. No hay ninguna pantalla que te las vuelva a enseñar en claro.',
        },
        {
          t: 'Qué lee el asistente',
          d: 'El correo que tienes abierto y, cuando se lo pides, los correos que hay que buscar o resumir. No se venden datos a terceros.',
        },
        {
          t: 'Quién pulsa los botones',
          d: 'Tú. Enviar, borrar o modificar algo en un servicio conectado siempre pasa por una confirmación tuya: el asistente deja la tarjeta y tú pulsas Ejecutar.',
          screen: 'chat-proposal',
          highlight: 'proposal',
        },
        {
          t: 'Cómo sales',
          d: 'Puedes quitar una cuenta de correo o cerrar sesión cuando quieras. Al quitar la cuenta, Nukli deja de acceder a ella.',
          screen: 'settings-account',
          highlight: 'plan',
        },
      ],
      tips: [
        'Consejo general más allá de Nukli: ninguna empresa seria te pedirá la contraseña por correo electrónico.',
        'Si dudas de un correo concreto, pregúntaselo al asistente antes de pulsar ningún enlace.',
      ],
      faq: [
        {
          q: '¿Se guardan mis correos en un servidor?',
          a: 'Nukli guarda una copia para poder enseñarte la bandeja y buscar rápido. Tu proveedor sigue teniendo los originales.',
        },
        {
          q: '¿Puedo usar Nukli sin IA?',
          a: 'Sí. Es un cliente de correo completo; las funciones de IA se usan solo cuando las pides.',
        },
      ],
    },
    en: {
      title: 'Privacy: what Nukli sees and what it does not',
      lead: 'The fair question when an app asks for your email. Here is the plain answer.',
      answer:
        'Nukli connects to your mail with encrypted credentials (AES-256-GCM). With Gmail and Microsoft you sign in on their own page and Nukli never sees your password. Your data is not sold. The assistant reads the email you open so it can help, and anything that changes things is confirmed by you.',
      steps: [
        {
          t: 'How it signs in',
          d: 'With Gmail and Microsoft, through the provider’s own authorisation (you sign in on their page). With IMAP, using an app password you can revoke at any time.',
          screen: 'settings-accounts',
          highlight: 'add',
        },
        {
          t: 'How the keys are stored',
          d: 'Encrypted with AES-256-GCM. No screen ever shows them back to you in the clear.',
        },
        {
          t: 'What the assistant reads',
          d: 'The email you have open and, when you ask, the emails it needs to search or summarise. No data is sold to third parties.',
        },
        {
          t: 'Who presses the buttons',
          d: 'You do. Sending, deleting or changing anything in a connected service always goes through your confirmation: the assistant leaves the card and you press Run.',
          screen: 'chat-proposal',
          highlight: 'proposal',
        },
        {
          t: 'How you leave',
          d: 'You can remove a mail account or sign out whenever you like. Remove the account and Nukli stops accessing it.',
          screen: 'settings-account',
          highlight: 'plan',
        },
      ],
      tips: [
        'General advice beyond Nukli: no serious company asks for your password by email.',
        'If a particular email worries you, ask the assistant before clicking any link.',
      ],
      faq: [
        {
          q: 'Are my emails stored on a server?',
          a: 'Nukli keeps a copy so it can show your inbox and search quickly. Your provider still holds the originals.',
        },
        {
          q: 'Can I use Nukli without AI?',
          a: 'Yes. It is a complete email client; the AI features only run when you ask for them.',
        },
      ],
    },
  },

  {
    slug: 'nukli-on-your-phone',
    id: 'web-and-mobile',
    category: 'more',
    icon: 'smartphone',
    level: 'basic',
    plan: 'free',
    minutes: 2,
    topics: [
      'mòbil', 'móvil', 'mobile', 'phone', 'teléfono', 'telèfon', 'tablet', 'navegador', 'browser',
      'app del móvil', 'ios', 'android', 'web app', 'usar fuera de casa', 'otro ordenador',
    ],
    ca: {
      title: 'Fer servir Nukli al mòbil i en un altre ordinador',
      lead: 'No hi ha app de mòbil, però sí la mateixa Nukli dins del navegador, entris des d’on entris.',
      answer:
        'Obre mail.nukliapp.com al navegador del mòbil, de la tauleta o de qualsevol ordinador, i entra amb el teu compte de Nukli. És la mateixa app, amb els mateixos correus. No cal instal·lar res.',
      steps: [
        {
          t: 'Obre mail.nukliapp.com',
          d: 'Al navegador que facis servir. Funciona igual al mòbil que a l’ordinador de la feina.',
          screen: 'mobile-inbox',
          highlight: 'list',
        },
        {
          t: 'Entra amb el teu compte de Nukli',
          d: 'El mateix correu i contrasenya de sempre. Els comptes que ja tens connectats hi surten sols.',
          screen: 'mobile-inbox',
          highlight: 'menu',
        },
        {
          t: 'Desa-t’ho a la pantalla d’inici',
          d: 'Al mòbil pots afegir la pàgina a la pantalla d’inici i quedarà com una app més. A dins, les pantalles van apilades: llista, correu i assistent, amb la fletxa de tornar.',
          screen: 'mobile-reader',
          highlight: 'back',
        },
      ],
      tips: [
        'La pantalla petita ensenya les zones d’una en una: llista, correu i assistent, amb la fletxa de tornar.',
        'Al mòbil no cal instal·lar res ni actualitzar res: sempre tens l’última versió.',
      ],
      faq: [
        {
          q: 'Hi ha app per a iPhone o Android?',
          a: 'Ara mateix no. Al telèfon la resposta és el navegador: mail.nukliapp.com.',
        },
      ],
    },
    es: {
      title: 'Usar Nukli en el móvil y en otro ordenador',
      lead: 'No hay app de móvil, pero sí la misma Nukli dentro del navegador, entres desde donde entres.',
      answer:
        'Abre mail.nukliapp.com en el navegador del móvil, la tableta o cualquier ordenador, y entra con tu cuenta de Nukli. Es la misma app, con los mismos correos. No hay que instalar nada.',
      steps: [
        {
          t: 'Abre mail.nukliapp.com',
          d: 'En el navegador que uses. Funciona igual en el móvil que en el ordenador del trabajo.',
          screen: 'mobile-inbox',
          highlight: 'list',
        },
        {
          t: 'Entra con tu cuenta de Nukli',
          d: 'El mismo correo y contraseña de siempre. Las cuentas que ya tienes conectadas salen solas.',
          screen: 'mobile-inbox',
          highlight: 'menu',
        },
        {
          t: 'Guárdalo en la pantalla de inicio',
          d: 'En el móvil puedes añadir la página a la pantalla de inicio y quedará como una app más. Dentro, las pantallas van apiladas: lista, correo y asistente, con la flecha de volver.',
          screen: 'mobile-reader',
          highlight: 'back',
        },
      ],
      tips: [
        'La pantalla pequeña enseña las zonas de una en una: lista, correo y asistente, con la flecha de volver.',
        'En el móvil no hay que instalar ni actualizar nada: siempre tienes la última versión.',
      ],
      faq: [
        {
          q: '¿Hay app para iPhone o Android?',
          a: 'Ahora mismo no. En el teléfono la respuesta es el navegador: mail.nukliapp.com.',
        },
      ],
    },
    en: {
      title: 'Using Nukli on your phone and on another computer',
      lead: 'There is no mobile app, but there is the same Nukli inside your browser, wherever you sign in.',
      answer:
        'Open mail.nukliapp.com in the browser on your phone, tablet or any computer and sign in with your Nukli account. It is the same app with the same mail. Nothing to install.',
      steps: [
        {
          t: 'Open mail.nukliapp.com',
          d: 'In whichever browser you use. It works the same on a phone as on your work computer.',
          screen: 'mobile-inbox',
          highlight: 'list',
        },
        {
          t: 'Sign in with your Nukli account',
          d: 'The same email and password as always. The accounts you have connected show up by themselves.',
          screen: 'mobile-inbox',
          highlight: 'menu',
        },
        {
          t: 'Save it to your home screen',
          d: 'On a phone you can add the page to your home screen and it behaves like any other app. Inside, the screens are stacked: list, email and assistant, with the back arrow.',
          screen: 'mobile-reader',
          highlight: 'back',
        },
      ],
      tips: [
        'A small screen shows the areas one at a time: list, email and assistant, with the back arrow.',
        'On a phone there is nothing to install or update: you always have the latest version.',
      ],
      faq: [
        {
          q: 'Is there an iPhone or Android app?',
          a: 'Not right now. On a phone the answer is the browser: mail.nukliapp.com.',
        },
      ],
    },
  },

  {
    slug: 'keyboard-shortcuts',
    id: 'shortcuts',
    category: 'more',
    icon: 'keyboard',
    level: 'medium',
    plan: 'free',
    minutes: 2,
    topics: [
      'dreceres', 'atajos', 'shortcuts', 'teclado', 'teclat', 'keyboard', 'sin ratón', 'más rápido',
      'combinación de teclas',
    ],
    ca: {
      title: 'Dreceres de teclat que val la pena saber',
      lead: 'Poques i útils. No cal aprendre-se’n vint.',
      answer:
        'Les tres que compten: ⌘/Ctrl + F obre el cercador, ⌘/Ctrl + Enter envia el correu que estàs escrivint, i Escapada tanca el que tinguis obert (cercador o resposta). El zoom és ⌘/Ctrl amb + i −.',
      steps: [
        {
          t: 'Buscar: ⌘ + F (Ctrl + F a Windows)',
          d: 'Obre el cercador de la llista i hi posa el cursor directament.',
          screen: 'inbox',
          highlight: 'search',
        },
        {
          t: 'Enviar: ⌘ + Enter (Ctrl + Enter)',
          d: 'Envia el correu que estàs escrivint sense buscar el botó.',
          screen: 'reader',
          highlight: 'actions',
        },
        {
          t: 'Sortir: Escapada',
          d: 'Tanca el cercador o descarta la resposta que tens oberta.',
        },
        {
          t: 'Mida de la lletra: ⌘ amb + i −',
          d: 'Amplia o redueix tota la finestra. Amb ⌘ + 0 tornes a la mida normal.',
        },
      ],
      tips: [
        'Si fas doble clic a la vora de dalt de la caixa de resposta, torna a la seva alçada normal.',
      ],
      faq: [
        {
          q: 'Hi ha més dreceres?',
          a: 'Aquestes són les que cobreixen el 90 % del dia a dia. La resta de coses es fan igual de ràpid amb el botó dret sobre el correu.',
        },
      ],
    },
    es: {
      title: 'Atajos de teclado que vale la pena saber',
      lead: 'Pocos y útiles. No hace falta aprenderse veinte.',
      answer:
        'Los tres que cuentan: ⌘/Ctrl + F abre el buscador, ⌘/Ctrl + Enter envía el correo que estás escribiendo, y Escape cierra lo que tengas abierto (buscador o respuesta). El zoom es ⌘/Ctrl con + y −.',
      steps: [
        {
          t: 'Buscar: ⌘ + F (Ctrl + F en Windows)',
          d: 'Abre el buscador de la lista y pone el cursor directamente.',
          screen: 'inbox',
          highlight: 'search',
        },
        {
          t: 'Enviar: ⌘ + Enter (Ctrl + Enter)',
          d: 'Envía el correo que estás escribiendo sin buscar el botón.',
          screen: 'reader',
          highlight: 'actions',
        },
        {
          t: 'Salir: Escape',
          d: 'Cierra el buscador o descarta la respuesta que tienes abierta.',
        },
        {
          t: 'Tamaño de letra: ⌘ con + y −',
          d: 'Amplía o reduce toda la ventana. Con ⌘ + 0 vuelves al tamaño normal.',
        },
      ],
      tips: [
        'Si haces doble clic en el borde superior de la caja de respuesta, vuelve a su altura normal.',
      ],
      faq: [
        {
          q: '¿Hay más atajos?',
          a: 'Estos cubren el 90 % del día a día. Lo demás se hace igual de rápido con el botón derecho sobre el correo.',
        },
      ],
    },
    en: {
      title: 'Keyboard shortcuts worth knowing',
      lead: 'Few and useful. No need to memorise twenty.',
      answer:
        'The three that matter: ⌘/Ctrl + F opens search, ⌘/Ctrl + Enter sends the email you are writing, and Escape closes whatever is open (search or reply). Zoom is ⌘/Ctrl with + and −.',
      steps: [
        {
          t: 'Search: ⌘ + F (Ctrl + F on Windows)',
          d: 'Opens the list search and puts the cursor straight in it.',
          screen: 'inbox',
          highlight: 'search',
        },
        {
          t: 'Send: ⌘ + Enter (Ctrl + Enter)',
          d: 'Sends the email you are writing without hunting for the button.',
          screen: 'reader',
          highlight: 'actions',
        },
        {
          t: 'Get out: Escape',
          d: 'Closes search or discards the reply you have open.',
        },
        {
          t: 'Text size: ⌘ with + and −',
          d: 'Zooms the whole window in or out. ⌘ + 0 returns to normal.',
        },
      ],
      tips: [
        'Double-clicking the top edge of the reply box returns it to its normal height.',
      ],
      faq: [
        {
          q: 'Are there more shortcuts?',
          a: 'These cover 90% of everyday use. Everything else is just as fast with a right-click on the email.',
        },
      ],
    },
  },

  {
    slug: 'invite-friends',
    id: 'referrals',
    category: 'more',
    icon: 'gift',
    level: 'basic',
    plan: 'free',
    minutes: 2,
    topics: [
      'convidar', 'invitar', 'referidos', 'referits', 'referrals', 'invite', 'enlace de invitación',
      'meses gratis', 'mesos gratis', 'crédito', 'crèdit', 'recomendar',
    ],
    ca: {
      title: 'Convidar gent i guanyar mesos gratis',
      lead: 'Si Nukli et va bé, l’enllaç d’invitació et pot pagar la subscripció.',
      answer:
        'Al panell de referits tens el teu enllaç personal. Quan algú s’hi doni d’alta i passi a un pla de pagament, guanyes un crèdit; els crèdits es canvien per mesos gratis de Pro, Pro+ o Ultra.',
      steps: [
        {
          t: 'Obre l’apartat de referits',
          d: 'És el botó daurat de la barra d’icones de l’esquerra.',
          screen: 'referrals',
          highlight: 'rail',
        },
        {
          t: 'Copia el teu enllaç',
          d: 'Un botó el copia i un altre te’l prepara com a correu per enviar-lo.',
          screen: 'referrals',
          highlight: 'link',
        },
        {
          t: 'Espera que s’hi apuntin',
          d: 'Quan una persona convidada passa a premium, et sumes un crèdit. Al panell veus quanta gent has convidat.',
        },
        {
          t: 'Bescanvia els crèdits',
          d: 'Un mes de Pro val 1 crèdit; Pro+ en val 3 i Ultra 20. Es bescanvien des del mateix panell.',
          screen: 'referrals',
          highlight: 'redeem',
        },
      ],
      tips: [
        'La persona convidada ha d’entrar pel teu enllaç per associar-la al teu compte.',
      ],
      faq: [
        {
          q: 'Hi ha límit?',
          a: 'No hi ha límit de gent convidada; només cal que cada un s’hi apunti amb el teu enllaç.',
        },
      ],
    },
    es: {
      title: 'Invitar gente y ganar meses gratis',
      lead: 'Si Nukli te va bien, el enlace de invitación puede pagarte la suscripción.',
      answer:
        'En el panel de referidos tienes tu enlace personal. Cuando alguien se dé de alta con él y pase a un plan de pago, ganas un crédito; los créditos se cambian por meses gratis de Pro, Pro+ o Ultra.',
      steps: [
        {
          t: 'Abre el apartado de referidos',
          d: 'Es el botón dorado de la barra de iconos de la izquierda.',
          screen: 'referrals',
          highlight: 'rail',
        },
        {
          t: 'Copia tu enlace',
          d: 'Un botón lo copia y otro te lo prepara como correo para enviarlo.',
          screen: 'referrals',
          highlight: 'link',
        },
        {
          t: 'Espera a que se apunten',
          d: 'Cuando una persona invitada pasa a premium, sumas un crédito. En el panel ves a cuánta gente has invitado.',
        },
        {
          t: 'Canjea los créditos',
          d: 'Un mes de Pro vale 1 crédito; Pro+ vale 3 y Ultra 20. Se canjean desde el mismo panel.',
          screen: 'referrals',
          highlight: 'redeem',
        },
      ],
      tips: [
        'La persona invitada tiene que entrar por tu enlace para quedar asociada a tu cuenta.',
      ],
      faq: [
        {
          q: '¿Hay límite?',
          a: 'No hay límite de gente invitada; solo hace falta que cada uno entre con tu enlace.',
        },
      ],
    },
    en: {
      title: 'Inviting people and earning free months',
      lead: 'If Nukli works for you, the invite link can pay for your subscription.',
      answer:
        'The referrals panel holds your personal link. When somebody signs up with it and moves to a paid plan, you earn a credit; credits are exchanged for free months of Pro, Pro+ or Ultra.',
      steps: [
        {
          t: 'Open the referrals section',
          d: 'The golden button in the icon bar on the left.',
          screen: 'referrals',
          highlight: 'rail',
        },
        {
          t: 'Copy your link',
          d: 'One button copies it, another prepares it as an email to send.',
          screen: 'referrals',
          highlight: 'link',
        },
        {
          t: 'Wait for them to join',
          d: 'When an invited person goes premium, you earn a credit. The panel shows how many people you have invited.',
        },
        {
          t: 'Redeem your credits',
          d: 'A month of Pro costs 1 credit; Pro+ costs 3 and Ultra 20. Redeem them from the same panel.',
          screen: 'referrals',
          highlight: 'redeem',
        },
      ],
      tips: [
        'The invited person has to arrive through your link to be linked to your account.',
      ],
      faq: [
        {
          q: 'Is there a limit?',
          a: 'No limit on how many people you invite; each just has to come in through your link.',
        },
      ],
    },
  },

  {
    slug: 'if-something-goes-wrong',
    id: 'troubleshooting',
    category: 'more',
    icon: 'life-buoy',
    level: 'basic',
    plan: 'free',
    minutes: 4,
    topics: [
      'no funciona', 'error', 'problema', 'ayuda', 'ajuda', 'help', 'no me llegan correos',
      'no rep correus', 'no sincroniza', 'se ha quedado colgado', 'lento', 'lent', 'no envía',
      'algo va mal', 'soporte', 'suport',
    ],
    ca: {
      title: 'Si alguna cosa no rutlla: què mirar primer',
      lead: 'Abans de patir, quatre comprovacions que arreglen gairebé tot.',
      answer:
        'Prem el botó de sincronitzar, comprova que el compte no dona error a la columna de bústies, mira si tens connexió, i tanca i torna a obrir la app. Si continua, envia’ns un comentari des del botó de feedback de la barra d’icones.',
      steps: [
        {
          t: 'Sincronitza a mà',
          d: 'El botó de sincronitzar força la baixada de correu nou. Si feia estona que no arribava res, sovint és això.',
        },
        {
          t: 'Mira si el compte dona error',
          d: 'A la columna de bústies, un compte amb problemes es queixa. Sol ser una contrasenya caducada: torna a connectar-lo.',
          screen: 'inbox',
          highlight: 'mailboxes',
        },
        {
          t: 'Comprova la connexió',
          d: 'Obre qualsevol pàgina web. Si no va, el problema no és Nukli.',
        },
        {
          t: 'Tanca i torna a obrir',
          d: 'Sí, el consell de sempre. Funciona més del que sembla, i no perds res: els esborranys es queden desats.',
        },
        {
          t: 'Explica’ns-ho',
          d: 'A la barra d’icones hi ha el botó de comentaris. Explica què estaves fent i què ha passat; ens arriba directament.',
          screen: 'inbox',
          highlight: 'rail',
        },
      ],
      tips: [
        'Si no t’arriba un correu que t’han enviat, mira la carpeta de correu brossa abans de res.',
        'Si va lent el primer dia, és normal: encara està baixant l’històric.',
      ],
      faq: [
        {
          q: 'M’he quedat sense quota d’IA i pensava que era una errada',
          a: 'Quan la quota s’acaba, l’assistent t’ho diu. El correu segueix funcionant igual.',
        },
        {
          q: 'He esborrat un correu sense voler',
          a: 'Mira la paperera del compte: hi haurà d’estar fins que la buidis tu o el teu proveïdor.',
        },
      ],
    },
    es: {
      title: 'Si algo no funciona: qué mirar primero',
      lead: 'Antes de sufrir, cuatro comprobaciones que arreglan casi todo.',
      answer:
        'Pulsa el botón de sincronizar, comprueba que la cuenta no da error en la columna de buzones, mira si tienes conexión, y cierra y vuelve a abrir la app. Si sigue, mándanos un comentario desde el botón de feedback de la barra de iconos.',
      steps: [
        {
          t: 'Sincroniza a mano',
          d: 'El botón de sincronizar fuerza la bajada de correo nuevo. Si hacía rato que no llegaba nada, muchas veces es eso.',
        },
        {
          t: 'Mira si la cuenta da error',
          d: 'En la columna de buzones, una cuenta con problemas se queja. Suele ser una contraseña caducada: vuelve a conectarla.',
          screen: 'inbox',
          highlight: 'mailboxes',
        },
        {
          t: 'Comprueba la conexión',
          d: 'Abre cualquier página web. Si no va, el problema no es Nukli.',
        },
        {
          t: 'Cierra y vuelve a abrir',
          d: 'Sí, el consejo de siempre. Funciona más de lo que parece, y no pierdes nada: los borradores se quedan guardados.',
        },
        {
          t: 'Cuéntanoslo',
          d: 'En la barra de iconos está el botón de comentarios. Explica qué estabas haciendo y qué ha pasado; nos llega directamente.',
          screen: 'inbox',
          highlight: 'rail',
        },
      ],
      tips: [
        'Si no te llega un correo que te han mandado, mira la carpeta de correo basura antes que nada.',
        'Si va lento el primer día, es normal: todavía está bajando el histórico.',
      ],
      faq: [
        {
          q: 'Me he quedado sin cuota de IA y pensaba que era un fallo',
          a: 'Cuando la cuota se acaba, el asistente te lo dice. El correo sigue funcionando igual.',
        },
        {
          q: 'He borrado un correo sin querer',
          a: 'Mira la papelera de la cuenta: estará ahí hasta que la vacíes tú o tu proveedor.',
        },
      ],
    },
    en: {
      title: 'If something goes wrong: what to check first',
      lead: 'Before you worry, four checks that fix almost everything.',
      answer:
        'Press the sync button, check the account is not showing an error in the mailboxes column, make sure you have a connection, and close and reopen the app. If it persists, send us a note from the feedback button in the icon bar.',
      steps: [
        {
          t: 'Sync by hand',
          d: 'The sync button forces a fetch of new mail. If nothing had arrived for a while, that is often it.',
        },
        {
          t: 'See whether the account is erroring',
          d: 'In the mailboxes column, an account with problems complains. It is usually an expired password: reconnect it.',
          screen: 'inbox',
          highlight: 'mailboxes',
        },
        {
          t: 'Check your connection',
          d: 'Open any web page. If that fails, the problem is not Nukli.',
        },
        {
          t: 'Close it and open it again',
          d: 'Yes, the oldest advice there is. It works more often than you would think, and you lose nothing: drafts are saved.',
        },
        {
          t: 'Tell us about it',
          d: 'The icon bar has a feedback button. Say what you were doing and what happened; it reaches us directly.',
          screen: 'inbox',
          highlight: 'rail',
        },
      ],
      tips: [
        'If an email someone sent never arrived, check the junk folder before anything else.',
        'If it feels slow on the first day, that is normal: it is still downloading your history.',
      ],
      faq: [
        {
          q: 'I ran out of AI allowance and thought it was a bug',
          a: 'When the allowance runs out the assistant says so. Email keeps working as usual.',
        },
        {
          q: 'I deleted an email by accident',
          a: 'Look in the account’s trash: it stays there until you or your provider empties it.',
        },
      ],
    },
  },
];
